import React from 'react'
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import dealers from '../Assests/dealers.jpg'
import lottery from '../Assests/lottery.jpg'
import dealer1 from '../Assests/dealer 1.jpg'
import distributor from '../Assests/distributor.jpg'
import SETTLE from '../Assests/settlejpg.jpg'
import report from '../Assests/report.png'
import returnpng from '../Assests/returns.jpg'
import reportJpg from '../Assests/Report.jpg'
import '../App.css';
import { useNavigate } from 'react-router-dom';
import CarouselComponent from '../Components/SlideNav';


function Home() {
    const navigate = useNavigate();

    return (
        <div>
            <CarouselComponent />
            {/* Other components and content */}

            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: 'black',
                    fontWeight: 'bold',
                    fontSize: 40,
                    gap: '1px',
                    height: 'calc(100vh - 8.5vh)',
                }}
            >

                <Card sx={{
                    width: '90%',
                    maxWidth: '350px',
                    height: 'auto',
                    maxHeight: '60vh',
                    minWidth: '200px',
                    margin: '10px'
                }}>
                    <CardActionArea onClick={() => { navigate("/stakeholders") }}>
                        <CardMedia
                            component="img"
                            height="200"
                            image={dealer1}
                            alt="dealers"
                        />

                        <CardContent onClick={() => navigate('/stakeholders')}>
                            <Typography gutterBottom variant="h7" component="div" sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                                DEALERS / DISTRIBUTORS
                            </Typography>
                        </CardContent>
                    </CardActionArea>
                    <CardActions>
                        <button class="cta" onClick={() => navigate('/stakeholders')}>
                            <span> Click Here</span>
                            <svg width="15px" height="10px" viewBox="0 0 13 10">
                                <path d="M1,5 L11,5"></path>
                                <polyline points="8 1 12 5 8 9"></polyline>
                            </svg>
                        </button>
                    </CardActions>
                </Card>

                <Card sx={{
                    width: '90%',
                    maxWidth: '350px',
                    height: 'auto',
                    maxHeight: '60vh',
                    minWidth: '200px',
                    margin: '10px'
                }}>
                    <CardActionArea onClick={() => { navigate("/lottery") }}>
                        <CardMedia
                            component="img"
                            height="200"
                            image={lottery}
                            alt="lottery"
                        />

                        <CardContent>
                            <Typography gutterBottom variant="h7" component="div" sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                                LOTTERIES
                            </Typography>
                        </CardContent>
                    </CardActionArea>
                    <CardActions>
                        <button class="cta" onClick={() => { navigate("/lottery") }}>
                            <span> Click Here</span>
                            <svg width="15px" height="10px" viewBox="0 0 13 10">
                                <path d="M1,5 L11,5"></path>
                                <polyline points="8 1 12 5 8 9"></polyline>
                            </svg>
                        </button>
                    </CardActions>
                </Card>



                <Card sx={{
                    width: '90%',
                    maxWidth: '350px',
                    height: 'auto',
                    maxHeight: '60vh',
                    minWidth: '200px',
                    margin: '10px'
                }}>
                    <CardActionArea onClick={() => navigate('/ReportMain')}>
                        <CardMedia
                            component="img"
                            height="200"
                            image={reportJpg}
                            alt="report"
                        />

                        <CardContent>
                            <Typography gutterBottom variant="h7" component="div" sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                                REPORTS
                            </Typography>
                        </CardContent>
                    </CardActionArea>
                    <CardActions>
                        <button class="cta" onClick={() => navigate('/ReportMain')}>
                            <span> Click Here</span>
                            <svg width="15px" height="10px" viewBox="0 0 13 10">
                                <path d="M1,5 L11,5"></path>
                                <polyline points="8 1 12 5 8 9"></polyline>
                            </svg>
                        </button>
                    </CardActions>
                </Card>

                <Card sx={{
                    width: '90%',
                    maxWidth: '350px',
                    height: 'auto',
                    maxHeight: '60vh',
                    minWidth: '200px',
                    margin: '10px'
                }}>
                    <CardActionArea onClick={() => navigate('/return')}>
                        <CardMedia
                            component="img"
                            height="200"
                            image={returnpng}
                            alt="report"
                        />

                        <CardContent>
                            <Typography gutterBottom variant="h7" component="div" sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                                RETURNS
                            </Typography>
                        </CardContent>
                    </CardActionArea>
                    <CardActions>
                        <button class="cta" onClick={() => navigate('/return')}>
                            <span> Click Here</span>
                            <svg width="15px" height="10px" viewBox="0 0 13 10">
                                <path d="M1,5 L11,5"></path>
                                <polyline points="8 1 12 5 8 9"></polyline>
                            </svg>
                        </button>
                    </CardActions>
                </Card>
                <Card sx={{
                    width: '90%',
                    maxWidth: '350px',
                    height: 'auto',
                    maxHeight: '60vh',
                    minWidth: '200px',
                    margin: '10px'
                }}>
                    <CardActionArea onClick={() => navigate('/settle')}>
                        <CardMedia
                            component="img"
                            height="200"
                            image={SETTLE}
                            alt="report"
                        />

                        <CardContent>
                            <Typography gutterBottom variant="h7" component="div" sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                                SETTLEMENTS
                            </Typography>
                        </CardContent>
                    </CardActionArea>
                    <CardActions>
                        <button class="cta" onClick={() => navigate('/settle')}>
                            <span> Click Here</span>
                            <svg width="15px" height="10px" viewBox="0 0 13 10">
                                <path d="M1,5 L11,5"></path>
                                <polyline points="8 1 12 5 8 9"></polyline>
                            </svg>
                        </button>
                    </CardActions>
                </Card>
            </div>
        </div>
    )
}

export default Home